import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, BookOpen, FileText } from 'lucide-react';

const categories = ['All', 'Reports', 'Case Studies', 'Policy Briefs', 'Working Papers'];

const publications = [
  {
    type: 'Report',
    title: 'Financing Climate Resilience in Urban Africa',
    date: 'March 15, 2024',
    description: 'Analysis of urban climate finance mechanisms and their effectiveness.',
    icon: FileText
  },
  {
    type: 'Case Study',
    title: 'Green Bonds for Renewable Energy',
    date: 'March 10, 2024',
    description: 'Success stories from East African renewable energy projects.',
    icon: BookOpen
  },
  {
    type: 'Policy Brief',
    title: 'Carbon Markets in Africa',
    date: 'March 5, 2024',
    description: 'Policy recommendations for developing carbon markets.',
    icon: Calendar
  }
];

export default function ResearchGrid() {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex overflow-x-auto pb-4 mb-8 gap-4">
          {categories.map((category) => (
            <button
              key={category}
              className="px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap
                first:bg-green-600 first:text-white
                [&:not(:first-child)]:bg-gray-100 [&:not(:first-child)]:text-gray-600
                [&:not(:first-child)]:hover:bg-gray-200 transition-colors"
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {publications.map((pub, index) => {
            const Icon = pub.icon;
            return (
              <motion.div
                key={pub.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow p-6"
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="bg-green-100 p-2 rounded-lg">
                    <Icon className="h-5 w-5 text-green-600" />
                  </div>
                  <span className="text-sm font-medium text-green-600">{pub.type}</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{pub.title}</h3>
                <p className="text-gray-600 mb-4">{pub.description}</p>
                <div className="flex items-center text-sm text-gray-500">
                  <Calendar className="h-4 w-4 mr-2" />
                  {pub.date}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}